import React from "react";
import { Table, Button } from "reactstrap";
import { MINIJUEGOS, HISTORIAS, PLANETAS, NIVELES, CINTURONES } from "./consts_act";

export default class TablaAlumnos extends React.Component {
  render() {
    if (!this.props.data) return null;
    console.warn(this.props)
    return (
      <Table hover className="mb-0">
        <thead>
          <tr>
     
            <th className="text-center">Alumno</th>
       {/*      <th className="text-center">
              Cinturones de Asteroides completados
            </th>
            <th className="text-center">Paso de Nivel</th>
            <th className="text-center">Planetas desbloqueados</th>
            <th className="text-center">Historias Leídas</th>
            <th className="text-center">Minijuegos Completados</th> */}
          </tr>
        </thead>
        <tbody>
          {this.props.data.map((e, index) => {
            return (
              <tr key={e.id}>
                
                <td className="text-center">{e.usuario}</td>

              {/*   <td className="text-center">
                  <Button
                    className="mb-2 mr-2"
                    color="warning"
                    onClick={() => this.props.openActivity(e,CINTURONES)}
                  >
                    Ver Cinturones
                  </Button>
                </td>

                
                <td className="text-center">
                  <Button
                    className="mb-2 mr-2"
                    color="warning"
                    onClick={() => this.props.openActivity(e,NIVELES)}
                  >
                    Ver Niveles
                  </Button>
                </td>

                
                <td className="text-center">
                  <Button
                    className="mb-2 mr-2"
                    color="warning"
                    onClick={() => this.props.openActivity(e,PLANETAS)}
                  >
                    Ver Planetas
                  </Button>
                </td>

                
                <td className="text-center">
                  <Button
                    className="mb-2 mr-2"
                    color="warning"
                    onClick={() => this.props.openActivity(e,HISTORIAS)}
                  >
                    Ver Historias
                  </Button>
                </td>

                
                <td className="text-center">
                  <Button
                    className="mb-2 mr-2"
                    color="warning"
                    onClick={() => this.props.openActivity(e,MINIJUEGOS)}
                  >
                    Ver Minijuegos
                  </Button>
                </td> */}
              </tr>
            );
          })}
          <div>
            <nav
              aria-label="Page"
              className="d-flex w-100 justify-content-center  "
            >
              <ul className="pagination">
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(0)}
                >
                  <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">«</span>
                    <span className="sr-only"> Pagina Anterior</span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link">{this.props.page}</a>
                </li>
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(1)}
                >
                  <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">»</span>
                    <span className="sr-only">Proxima Pagina</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/ubicacion/Provincia/component/AlumnosList.js